module.exports = __webpack_public_path__ + "static/media/13.4ab4a3c7.svg";